import BenefitsOrdersTable  from "./benefits-components/BenefitsOrdersTable"

export const BenefitsOrderDetails = () => {
  return (
    <BenefitsOrdersTable />
  )
}
